import React from 'react';
import classNames from 'classnames';
import Button from './Button';
import styles from './InPlaceEditControls.module.scss';
import useAppSelector from '../app/redux/useAppSelector';
import LoadingIndicator from './LoadingIndicator';

interface InPlaceEditControlsProps {
  saving: boolean;
  savingDisabled: boolean;
  onSaveClick(): void;
  onCancelClick(): void;
}

const InPlaceEditControls = ({
  saving,
  savingDisabled,
  onSaveClick,
  onCancelClick,
}: InPlaceEditControlsProps) => {
  const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen);

  return (
    <div
      className={classNames(styles.inPlaceEditControls, {
        [styles.isSidebarOpen]: isSidebarOpen,
      })}
    >
      <Button
        variant="primary"
        onClick={onSaveClick}
        disabled={saving || savingDisabled}
      >
        {saving ? <LoadingIndicator delay={0} adaptColor /> : 'Save'}
      </Button>
      <Button variant="secondary" onClick={onCancelClick} disabled={saving}>
        Cancel
      </Button>
    </div>
  );
};

export default InPlaceEditControls;
